import { createSelector } from 'reselect';
import { toActiveLocale } from '../../services/Translation';
import { DEFAULT_COUNTRY_CODE } from '../../constants/countries';


const getFormData = state => state.application.formData;
const getVisaTypesFromState = state => state.configs.config ? state.configs.config.visaTypes || [] : [];
const getCountriesFromState = state => state.configs.config ? state.configs.config.countries || [] : [];
const getLanguageFromState = state => state.app.language;

export const getTargetCountryId = createSelector(
  [getFormData, getVisaTypesFromState],
  (formData, visaTypes) => {
    if (!formData || !formData.visatypeId) return null;
    const visaType = visaTypes.find(i => i && i.uuid === formData.visatypeId);
    return visaType && visaType.countryId ? visaType.countryId : null;
  }
);

export const getTargetCountry = createSelector(
  [getTargetCountryId, getCountriesFromState],
  (targetCountryId, countries) => {
    if (!targetCountryId) return null;
    return countries.find(country => country && country.uuid === targetCountryId) || null;
  }
);

export const getTargetCountryName = createSelector(
  [getTargetCountry, getLanguageFromState],
  (targetCountry, lang) => {
    if (!targetCountry) return '';
    try {
      return toActiveLocale(targetCountry, lang) || '';
    } catch (error) {
      console.error('Error getting destination country name:', error);
      return '';
    }
  }
);

export const getTargetCountryCode = createSelector(
  [getTargetCountry],
  (targetCountry) => {
    if (!targetCountry || !targetCountry.code) return DEFAULT_COUNTRY_CODE;
      const { code } = targetCountry;
      return code.toLowerCase();
  }
)


// WEBPACK FOOTER //
// ./src/state/selectors/TargetCountrySelector.js